import { Box } from '@mui/material';
import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useLoginByTelegramTokenMutation } from '@generated/graphql';
import { CircularLoading, generateBase64, useToast } from '@myhrbox/myhrbox-frontend-core';
import { useTranslation } from 'react-i18next';
import useMe from 'store/user/useMe';
import useHandleLogin from 'pages/onboarding/Login/useHandleLogin';

const BOT_NAME = process.env.REACT_APP_BOT_NAME;

const TelegramLoginWidget = () => {
  const { me, loading: meLoading } = useMe();
  const { t } = useTranslation();
  const handleLogin = useHandleLogin();
  const telegramWrapperRef = useRef<HTMLDivElement>(null);

  const { showErrorToast } = useToast();

  const [searchParams] = useSearchParams();
  const searchObject = Object.fromEntries(searchParams);
  const { redirectUrl, ...telegramAuth } = searchObject;

  const token = searchParams.has('hash') ? generateBase64(JSON.stringify(telegramAuth)) : undefined;

  const [loginByTelegram, { loading }] = useLoginByTelegramTokenMutation();

  const setupTelegramWidget = () => {
    if (!BOT_NAME) {
      console.error('Отсутствует BOT_NAME');
      showErrorToast(t('errors.common'));
      return;
    }

    const scriptElement = document.createElement('script');
    scriptElement.src = 'https://telegram.org/js/telegram-widget.js?22';
    scriptElement.setAttribute('data-telegram-login', BOT_NAME);
    scriptElement.setAttribute('data-size', 'large');
    scriptElement.setAttribute('data-auth-url', window.location.href);
    scriptElement.setAttribute('data-request-access', 'write');

    scriptElement.async = true;

    telegramWrapperRef.current?.appendChild(scriptElement);
  };

  useEffect(() => {
    if (!me && !token) {
      setupTelegramWidget();
    }
  }, [meLoading, me]);

  useEffect(() => {
    if (token && !meLoading && !me) {
      loginByTelegram({
        variables: {
          token,
        },
      })
        .then((res) => {
          const loginByTelegramToken = res.data?.loginByTelegramToken;
          const accessToken = loginByTelegramToken?.accessToken;
          const refreshToken = loginByTelegramToken?.refreshToken;

          handleLogin(accessToken, refreshToken);
        })
        .catch(() => showErrorToast(t('errors.common')));
    }
  }, [token, me, meLoading]);

  if (loading || meLoading) return <CircularLoading />;

  return (
    <Box
      component='div'
      sx={{ mt: 2.5, mx: 'auto', width: 'fit-content' }}
      ref={telegramWrapperRef}
    />
  );
};

export default TelegramLoginWidget;
